import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ProgressMessage from 'components/Utils/ProgressMessage';
import Icon from 'components/Utils/NewIcon';
import MiscUtils from 'services/MiscUtils';
import './style.scss';
import DefaultModal from 'components/Utils/DefaultModal';
import PreviewDocumentModal from 'components/Modals/PreviewDocumentModal';
import DocumentUtils from 'services/DocumentUtils';
import { mobileCheck } from 'scenes/Telemedicine';

let linkRef = React.createRef();

const SmallResourcePreview = (props) => {
  const isMobile = mobileCheck();

  const [previewModal, setPreviewModal] = useState(false);
  const [loading, setLoading] = useState(props.loading || false);
  const [previewUrl, setPreviewUrl] = useState(props.previewUrl);
  const [type, setType] = useState(props.type);
  const isPDF = (props.url || '').indexOf('.pdf') >= 0 || type === 'application/pdf';
  const iconSrc = isPDF ? 'file-pdf' : 'image';

  const [previewIcon, setPreviewIcon] = useState(
    <Icon src={iconSrc} alt={props.url} height={props.height || '45px'} />,
  );

  function onPreviewClick() {
    if (isMobile) {
      downloadFile();
    } else {
      previewFile();
    }
  }

  async function downloadFile() {
    setLoading(true);
    let { fileUrl } = await DocumentUtils.getFileUrl(props.getFile, props.getFileInfo);

    let blob = await MiscUtils.urlToBlob(fileUrl);
    let url = MiscUtils.getBlobUrl(blob);

    let title = props.document?.title || props.title;

    const a = linkRef.current;
    a.download = title + '.pdf';
    a.href = url;
    a.click();
    a.href = '';
    setLoading(false);
  }

  return (
    <div>
      <a href="download" ref={linkRef} style={{ display: 'none' }}>
        Download Document
      </a>
      <div
        className="small-resource-preview"
        onClick={onPreviewClick}
        onMouseEnter={() => {
          if (!isPDF) previewFile(false);
        }}
      >
        {loading ? <ProgressMessage /> : previewIcon}
      </div>
      {previewModal && (
        <DefaultModal
          className="large-modal"
          key="preview-document-modal"
          content={
            <PreviewDocumentModal
              showFax={props.showFax}
              onClose={() => setPreviewModal(false)}
              type={type}
              url={previewUrl}
              title={props.title}
              patient={props.patient}
              document={props.document}
              button={props.button}
            />
          }
          isOpen={previewModal}
          onRequestClose={() => setPreviewModal(false)}
        />
      )}
    </div>
  );

  async function previewFile(openPreviewModal = true) {
    if (previewUrl !== undefined) return setPreviewModal(openPreviewModal);

    setLoading(true);

    let { fileUrl, type } = await DocumentUtils.getFileUrl(props.getFile, props.getFileInfo);
    setLoading(false);

    if (!isPDF) setPreviewIcon(<img className="preview" alt={props.url} src={fileUrl} />);

    setPreviewUrl(fileUrl);
    setPreviewModal(openPreviewModal);
    setType(type);
  }
};

SmallResourcePreview.propTypes = {
  url: PropTypes.string.isRequired,
  getFile: PropTypes.func,
  getFileInfo: PropTypes.func,
  patient: PropTypes.object,
  title: PropTypes.string,
  showFax: PropTypes.bool,
  isPatient: PropTypes.bool,
  document: PropTypes.object,
  button: PropTypes.element,
};

export default SmallResourcePreview;
